import { Paper, Title } from '@mantine/core';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AliasActivity } from '../types';

interface AliasActivityChartProps {
    data: AliasActivity[];
}

export const AliasActivityChart = ({ data }: AliasActivityChartProps) => {
    return (
        <Paper p="md" withBorder>
            <Title order={4} mb="md">Most Active Aliases</Title>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="aliasName" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="count" fill="#228be6" />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
};
